import { axios } from './request'
import qs from  "querystring"
// get 请求
const get = function (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}
// get-拼接参数的方式 ?param=''?
// {id:'123',te:'y'}
const getJoin = function (url, params) {
  let paramStr = url + '?'
  for (const k in params) {
    paramStr = paramStr + k + ':' + params[k] + '&'
  }
  paramStr = paramStr.replace(/:/g, '=')
  const paramArr = paramStr.split('')
  if (paramArr[paramArr.length - 1] === '&') {
    paramArr.pop()
  }
  const newParam = paramArr.join('')
  return new Promise((resolve, reject) => {
    axios.get(newParam)
      .then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err.data)
      })
  })
}
// POST 请求
const post = function (url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}
// PUT 请求
const put = function (url, data) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}
// DELETE 请求
const del = function (url, data) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

export default { get, post, put, del, getJoin }



// WEBPACK FOOTER //
// ./src/apiConfig/http.js